<template>
	<Teleport to="body">
		<div class="modal" :class="{ 'is-active': show }">
			<div class="modal-background" @click="close"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">{{ editingItem ? 'Edit folder' : 'Add new folder' }}</p>
					<button class="delete" aria-label="close" @click="close"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">Name</label>
						<div class="control">
							<input class="input" type="text" v-model="name" @keyup.enter="submit" />
						</div>
					</div>
					<div class="field">
						<label class="label">Images</label>
						<image-manager v-model:existing-src="existingImages" v-model:new-images="newImages"></image-manager>
					</div>
					<p class="help is-danger" v-if="error">{{ error }}</p>
					<p class="help is-danger" v-if="submitError">{{ submitError }}</p>
				</section>
				<footer class="modal-card-foot">
					<button class="button is-success" :class="{ 'is-loading': isSubmitting }" :disabled="isSubmitting" @click="submit">
						{{ editingItem ? 'Save' : 'Add' }}
					</button>
					<button class="button" @click="close">Cancel</button>
				</footer>
			</div>
		</div>
	</Teleport>
</template>

<script>
import ImageManager from '@/components/ImageManager.vue';

export default {
	name: 'AddGalleryModal',
	components: { ImageManager },
	props: {
		show: Boolean,
		editingItem: { type: Object, default: null },
		onSubmit: { type: Function, required: true },
	},
	emits: ['close'],
	data() {
		return {
			name: '',
			existingImages: [],
			newImages: [],
			error: '',
			isSubmitting: false,
			submitError: '',
		};
	},
	watch: {
		show(val) {
			if (val) this.populate();
		},
	},
	methods: {
		populate() {
			this.reset();
			if (this.editingItem) {
				this.name = this.editingItem.name || '';
				this.existingImages = this.editingItem.image.src.slice();
			}
		},
		async submit() {
			if (!this.name.trim()) {
				this.error = 'Please enter a name.';
				return;
			}
			if (this.existingImages.length === 0 && this.newImages.length === 0) {
				this.error = 'Please add at least one image.';
				return;
			}
			this.error = '';
			this.submitError = '';
			const payload = {
				name: this.name.trim(),
				existingImages: this.existingImages,
				newImages: this.newImages.map((img) => img.data),
			};
			this.isSubmitting = true;
			const result = await this.onSubmit({
				isEdit: !!this.editingItem,
				id: this.editingItem ? this.editingItem.id : null,
				payload,
			});
			this.isSubmitting = false;
			if (result && result.ok) {
				this.reset();
				this.$emit('close');
			} else {
				this.submitError = (result && result.error) || 'Could not save this item.';
			}
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		reset() {
			this.name = '';
			this.existingImages = [];
			this.newImages = [];
			this.error = '';
			this.isSubmitting = false;
			this.submitError = '';
		},
	},
};
</script>

<style scoped>
.modal {
	z-index: 1000;
}
.modal-card {
	width: 460px;
	max-width: 90vw;
}
</style>
